import EditPriceItem from "../../../EditPriceItem/EditPriceItem";
import CurrencyFormat from "react-currency-format";
import { roofColorChange } from "../../../../action";
import { useDispatch, useSelector } from "react-redux";
import { useColorPicker, usePremiumColorDetection, ColorGroup } from "../Common";

const MATCH_KEY = "roof";

const RoofColor = () => {
	const dispatch = useDispatch();
	const { params, const_var } = useSelector((state) => state.reducer);
	const { standard: standardColors, premium: premiumColors } = useColorPicker(const_var.color, const_var.selSidingOption || "", MATCH_KEY);
	const isPremiumSelected = usePremiumColorDetection(premiumColors, params.p_r_c);
	const isColorActive = (color) => {
		return params.p_r_c === color?.hex_value?.replace("#", "0x");
	};
	const handleColorSelect = (color) => {
		dispatch(roofColorChange("Roof", color));
	};
	return (
		<>
			<div className="tab-pane-header">
				<div className="tab-pane-label mr-1">
					Selected Color : &nbsp;
					<strong>{params.p_r_c_name}</strong>
				</div>
				{const_var.post_data.building && const_var.loginSession === true ? (
					<div className={`price-box`}>
						<EditPriceItem jsonObjValue={const_var.post_data.building?.roof_color_price} jsonObjKey="roof_color_price" />
					</div>
				) : (
					<div className="price-box-type-2">
						{const_var.hide_price_calculation !== 1 && const_var.loginSession === false && const_var.post_data.building?.roof_color_price !== 0 && (
							<CurrencyFormat value={const_var.post_data.building?.roof_color_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
						)}
					</div>
				)}
			</div>
			{standardColors.length > 0 && <ColorGroup colors={standardColors} onColorSelect={handleColorSelect} isColorActive={isColorActive} isPremium={false} title="Standard Colors" />}
			{premiumColors.length > 0 && <ColorGroup colors={premiumColors} onColorSelect={handleColorSelect} isColorActive={isColorActive} isPremium={true} title="Premium Colors" />}
		</>
	);
};

export default RoofColor;
